import { IMainScope } from '../../app/IMainScope';
import { ActionContext } from '../helpers/ActionContext';
import {
  ISubplaceCountsScope,
  ISubplaceTabsScope,
} from '../helpers/SubplaceCountsHelper';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ISchedule } from '../ServerApi/types/ISchedule';
import { CreateScheduleAction } from '../services/CreateScheduleAction';
import { DeleteSchedulesAction } from '../services/DeleteSchedulesAction';
import { SchedulePermissions } from '../services/SchedulePermissions';
import { SetScheduleStatusAction } from '../services/SetScheduleStatusAction';
import { IScheduleViewModel } from './CreateOrEditScheduleCtrl';
import { CreateOrEditScheduleViewModelMapper } from './CreateOrEditScheduleViewModelMapper';

export interface ISchedulePlaceScope extends IMainScope, ISubplaceCountsScope, ISubplaceTabsScope {
  // comes from parent scope (angular directive in ScheduleSpace)
  schedule: ISchedule;
  navigateToAllSchedules: () => void;
  reloadSpace: () => void;

  scheduleViewModel: IScheduleViewModel;
  scheduleStatus: { enabled: boolean };
  scheduledActionType: string;

  editMode: boolean;
  busy: boolean;
  beginEdit: ($event: JQueryEventObject) => void;
  cancelEdit: ($event: JQueryEventObject) => void;
  save: ($event: JQueryEventObject) => void;

  del: ($event: JQueryEventObject) => void;

  // Permissions
  canEditSchedule: () => boolean;
}

export class ScheduleSpaceDetailsCtrl {

  public static $inject = [
    '$scope',
    'SchedulePermissions',
    'CreateScheduleAction',
    'DeleteSchedulesAction',
    'SetScheduleStatusAction',
  ];

  constructor(
            $scope: ISchedulePlaceScope,
            SchedulePermissions: SchedulePermissions,
    private CreateScheduleAction: CreateScheduleAction,
    private DeleteSchedulesAction: DeleteSchedulesAction,
    private SetScheduleStatusAction: SetScheduleStatusAction,
  ) {
    const schedule = $scope.schedule;

    $scope.canEditSchedule = () => SchedulePermissions.canEditSchedule();

    $scope.scheduledActionType = schedule.scheduledAction;

    // Edit schedule
    $scope.beginEdit = () => {
      $scope.scheduleViewModel = CreateOrEditScheduleViewModelMapper.viewModelFromSchedule($scope.schedule);
      $scope.editMode = true;
    };
    $scope.cancelEdit = () => $scope.editMode = false;
    $scope.save = ($event: JQueryEventObject) => {
      $scope.busy = true;
      this.CreateScheduleAction.submitScheduleUpdate($scope.scheduleViewModel, $scope.schedule.name)
        .then(() => {
          $scope.editMode = false;
          $scope.reloadSpace();
        })
        .finally(() => $scope.busy = false);
    };

    $scope.scheduleStatus = {
      enabled: !!schedule.runNextAt
    };
    $scope.$watch('scheduleStatus.enabled', (newVal: boolean, oldVal: boolean) => {
      if (newVal !== oldVal) {
        const action = newVal
          ? this.SetScheduleStatusAction.enableSchedule(schedule)
          : this.SetScheduleStatusAction.disableSchedule(schedule);
        action.then(() => $scope.reloadSpace());
      }
    });

    const scheduleSet = Set.singleton(schedule, (s) => s.id);

    $scope.del = ($event: JQueryEventObject) => {
      this.DeleteSchedulesAction.deleteSchedules(scheduleSet, ActionContext.fromEvent($event))
        .then(() => $scope.navigateToAllSchedules());
    };
  }
}

Module.instance().controller('ScheduleSpaceDetailsCtrl', ScheduleSpaceDetailsCtrl);
